import React from 'react';
import { Modal, Switch } from '@mantine/core';
import classes from './pos-settings-modal.module.scss';

type PosSettingsModalProps = {
  opened: boolean;
  onClose: () => void;
  viewportWidth: number;
  isSubmitting: boolean;
  isSuperAdmin: boolean;
  requiresManagerApproval: boolean;
  onChangeRequiresManagerApproval: (next: boolean) => void;
  refundCodeViaPush: boolean;
  onChangeRefundCodeViaPush: (next: boolean) => void;
  rootClassName?: string;
};

export const PosSettingsModal: React.FC<PosSettingsModalProps> = ({
  opened,
  onClose,
  viewportWidth,
  isSubmitting,
  isSuperAdmin,
  requiresManagerApproval,
  onChangeRequiresManagerApproval,
  refundCodeViaPush,
  onChangeRefundCodeViaPush,
  rootClassName,
}) => {
  const handleClose = () => {
    if (isSubmitting) {
      return;
    }
    onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title="הגדרות POS"
      closeButtonProps={{ 'data-testid': 'settings-pos-config-close', disabled: isSubmitting } as Record<string, unknown>}
      size={viewportWidth >= 768 ? 'clamp(760px, 78vw, 1120px)' : 'md'}
      centered={viewportWidth >= 768}
      radius="md"
      closeOnClickOutside={!isSubmitting}
      closeOnEscape={!isSubmitting}
      classNames={{
        root: rootClassName,
        content: classes.modalContent,
        body: classes.modalViewport,
      }}
    >
      <div className={classes.modalBody} dir="rtl">
        <p className={classes.lead}>הגדרות אלה נשמרות ברמת המסעדה.</p>
        <div className={classes.list}>
          <label className={classes.row} htmlFor="pos-setting-general-item-approval">
            <div className={classes.textBlock}>
              <span className={classes.label}>פריט כללי באישור מנהל</span>
              <span className={classes.hint}>כאשר כבוי, עובד שאינו מנהל מוסיף פריט כללי בלי המתנה לאישור מנהל.</span>
            </div>
            <Switch
              id="pos-setting-general-item-approval"
              checked={requiresManagerApproval}
              onChange={(event) => {
                onChangeRequiresManagerApproval(event.currentTarget.checked);
              }}
              disabled={isSubmitting}
              data-testid="pos-setting-general-item-approval"
            />
          </label>
          {isSuperAdmin && (
            <label className={classes.row} htmlFor="pos-setting-refund-code-via-push">
              <div className={classes.textBlock}>
                <span className={classes.label}>קוד זיכוי דרך התראות push</span>
                <span className={classes.hint}>כאשר פעיל, קוד אימות זיכוי נשלח בהתראת PWA במקום במייל.</span>
              </div>
              <Switch
                id="pos-setting-refund-code-via-push"
                checked={refundCodeViaPush}
                onChange={(event) => {
                  onChangeRefundCodeViaPush(event.currentTarget.checked);
                }}
                disabled={isSubmitting}
                data-testid="pos-setting-refund-code-via-push"
              />
            </label>
          )}
        </div>
      </div>
    </Modal>
  );
};
